import qs from 'qs'
import { components, dictionary as DICTIONARY_COMPONENTS } from '@/mixins/components'

export default {
    components,
    metaInfo() {
        return {
            title: this.seo.seo_title || this.pagina.title || this.$configuracoes.seo_title || '',
            meta: this.meta
        }
    },
    data() {
        return {
            pagina: {
                contents: [],
            },
        }
    },
    computed: {
        mappedContents() {
            return this.pagina.contents.map(item => {
                return Object.assign({}, { component: this.$options.components[DICTIONARY_COMPONENTS[item.type]], content: item })
            })
        },
        seo() {
            return this.pagina.seo || {}
        },
        meta() {
            const keys = Object.keys(this.seo).filter(key => key !== 'title')
            return keys.map(key => {
                return { name: key, vmid: key, content: this.seo[key] }
            })
        },
        galerias() {
            return this.pagina.contents.filter(item => item.type == 'galeriaGeral')
        },
        hasAsideImage() {
            return this.galerias.find(item => item.type_gallery == 'gallery_onlyImages') != undefined
        },
        hasAsideVideo() {
            return this.pagina.contents.find(item => item.type == 'bannerHome') != undefined
        },
    },
    mounted() {
        this.loadPagina( this.$route.params.slug )
    },
    beforeRouteUpdate(to, from, next) {
        if ( to.name != this.$route.name || to.params.slug != this.$route.params.slug )
            this.loadPagina( to.params.slug )
        next()
    },
    methods: {
        loadPagina(slug = 'pagina-inicial', params = {}) {
            this.resetPagina()
            this.$axios
                .get(`paginas/${slug}?${qs.stringify(params)}`)
                .then(response => this.pagina = response.data)
        },
        resetPagina() {
            this.pagina = {
                contents: [],
            }
        },
    },
}